import React, { useEffect, useState, useRef } from "react";
import Swiper from "react-id-swiper";
import "swiper/swiper.min.css";
import "swiper/components/navigation/navigation.min.css";
import "swiper/components/pagination/pagination.min.css";
import "../portraitSlider/portraitSlider.css";
import "./landscapeSlider.css";
import { getRecommended } from "../api/core";
import Global from "../../global";
import SectionHeader from "../sectionHeader/sectionHeader";
import SwiperCore, { Navigation, Pagination } from "swiper/core";
import { Link } from "react-router-dom";
import { favourited, favourites } from "../javascript/function";
import { UserStore } from "../store/store";
import LazyDiv from "../lazy/lazydiv";
import Icon from "../icon/icon";
import { BORDER } from "../../global";
import { useTranslation } from "react-i18next";
SwiperCore.use([Navigation, Pagination]);

const RLandscapeSlider = (props) => {
  const init = { playlist: [] };
  const [lsplaylist, setLSPlaylist] = useState(init);
  const [loading, isLoading] = useState(true);
  const [error, SetError] = useState(false);
  const [desc, setDesc] = useState(false);
  const [news, setNews] = useState(false);
  const mounted = useRef(false);
  const currentUser = UserStore.useState((s) => s.user);
  const { t } = useTranslation(["translation"]);

  const params = {
    slidesPerView: 2,
    slidesPerGroup: 2,
    slidesPerGroupSkip: 1,
    spaceBetween: 5,
    centeredSlides: false,
    speed: 800,
    rtl: Global.RTL ? "rtl" : "",
    loop: false,
    observer: true,
    observeParents: true,
    breakpoints: {
      320: {
        slidesPerView: 1.5,
        spaceBetween: 5,
        slidesPerGroup: 1,
        navigation: {
          nextEl: ".recommnext",
          prevEl: ".recommprev",
        },
      },
      400: {
        slidesPerView: 2,
        spaceBetween: 5,
        slidesPerGroup: 2,
        navigation: {
          nextEl: ".recommnext",
          prevEl: ".recommprev",
        },
      },
      576: {
        slidesPerView: 3,
        spaceBetween: 5,
        slidesPerGroup: 3,
        navigation: {
          nextEl: ".recommnext",
          prevEl: ".recommprev",
        },
      },
      577: {
        slidesPerView: 2,
        spaceBetween: 5,
        slidesPerGroup: 2,
        navigation: {
          nextEl: ".recommnext",
          prevEl: ".recommprev",
        },
      },
      720: {
        slidesPerView: 2.5,
        spaceBetween: 5,
        slidesPerGroup: 2,
        navigation: {
          nextEl: ".recommnext",
          prevEl: ".recommprev",
        },
      },
      900: {
        slidesPerView: 3,
        spaceBetween: 5,
        slidesPerGroup: 3,
        navigation: {
          nextEl: ".recommnext",
          prevEl: ".recommprev",
        },
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 5,
        slidesPerGroup: 3,
        navigation: {
          nextEl: ".recommnext",
          prevEl: ".recommprev",
        },
      },
      1200: {
        slidesPerView: 3.5,
        spaceBetween: 8,
        slidesPerGroup: 3,
        navigation: {
          nextEl: ".recommnext",
          prevEl: ".recommprev",
        },
      },
      1300: {
        slidesPerView: 5,
        spaceBetween: 8,
        slidesPerGroup: 5,
        navigation: {
          nextEl: ".recommnext",
          prevEl: ".recommprev",
        },
      },
    },
    runCallbacksOnInit: true,
    onInit: (swiper) => {},
  };

  useEffect(() => {
    mounted.current = true;

    const playlistDetail = async (id, limit, mediaid, offset) => {
      /* eslint-disable no-unused-vars */
      const result = await getRecommended(id, limit, mediaid, offset).then(
        (result) => {
          if (mounted.current) {
            setLSPlaylist(result.data);
            SetError(false);
          }
        },
        (error) => {
          SetError(true);
        }
      );
      /* eslint-disable no-unused-vars */
    };
    const recomFinal = async (id, mediaid, offset) => {
      const res = await playlistDetail(id, 20, mediaid, offset);
    };
    recomFinal(
      Global.RVPL ? Global.RVPL : props.recomm,
      props.videoId,
      props.offset
    );

    if (mounted.current) {
      setDesc(true);
      setNews(false);
    }
    isLoading(false);

    return () => {
      mounted.current = false;
    };
  }, [props.recomm, props.videoId, props.offset]);
  if (!error && !loading && lsplaylist.size !== 0) {
    return (
      <div className="landscape">
        {props.titleCard ? (
          <SectionHeader
            title={t("label_YMAL")}
            linkTitle={""}
            link={""}
            header={true}
          ></SectionHeader>
        ) : (
          ""
        )}
        <div className="container-fluid ">
          <div className="col-sm-12 slider_container">
            <div className="slide-wrapper">
              <Swiper
                className="slide-slider-full swiper container"
                {...params}
                shouldSwiperUpdate
              >
                {lsplaylist.size !== 0
                  ? lsplaylist.playlist.map((item, index) => (
                      <div className="slide-items" key={index}>
                        <Link
                          className={
                            BORDER
                              ? "slide-one slide-two"
                              : "slide-one slide-two no-border"
                          }
                          to={
                            "/" +
                            props.match.params.AppId +
                            "/videoPage/" +
                            item.mediaid
                          }
                        >
                          {item.ContentType === "Premium" ? <Icon></Icon> : ""}
                          <LazyDiv
                            className={
                              BORDER ? "slide-image" : "slide-image no-border"
                            }
                            style={{
                              backgroundImage:
                                `url(` + item.images[0].src + `)`,
                            }}
                            orient={"landscape"}
                          >
                            <img
                              src={item.images[0].src}
                              style={{ display: "none" }}
                              alt=""
                            />
                          </LazyDiv>
                          <div
                            className={
                              desc && news
                                ? "slide-content showed"
                                : desc && !news
                                ? "slide-content"
                                : "slide-content hidden"
                            }
                          >
                            <h2>
                              {item.title}{" "}
                              {Global.FAVOURITES ? (
                                <span
                                  className="span"
                                  onClick={(event) => {
                                    favourites(
                                      event,
                                      item,
                                      "video",
                                      JSON.parse(
                                        localStorage.getItem("favourites")
                                      )
                                    );
                                  }}
                                >
                                  <i
                                    className={
                                      favourited(
                                        item.mediaid,
                                        currentUser.FAVOURITES
                                      )
                                        ? "ri-check-fill"
                                        : "ri-add-line"
                                    }
                                  ></i>
                                </span>
                              ) : (
                                ""
                              )}
                            </h2>
                            <div>
                              <span className="tag">{item.VIdeoDuration}</span>
                              <span className="tag">{item.PgRating}</span>
                            </div>
                            <p>{item.ShortDescription}</p>
                          </div>
                        </Link>
                      </div>
                    ))
                  : ""}
              </Swiper>
              <div
                id={`arrows_${"recomm"}`}
                className={"recommprev swiper-arrows swiper-button-prev"}
              />
              <div
                id={`arrows_${"recomm"}`}
                className={"recommnext swiper-arrows swiper-button-next"}
              />
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return <div></div>;
  }
};

export default RLandscapeSlider;
